import { Box, TextButton, type IconElement } from "@wix/design-system";
import { useMobile } from "../../../hooks/useMobile";

export const MenuItem = ({
  href,
  onMouseEnter,
  children,
  suffixIcon,
  prefixIcon,
}: {
  href?: string;
  onMouseEnter?: () => void;
  children: React.ReactNode;
  suffixIcon?: IconElement;
  prefixIcon?: IconElement;
}) => {
  const isMobile = useMobile();

  return (
    <Box height={isMobile ? "38px" : "auto"} width="100%">
      <TextButton
        size="small"
        skin="dark"
        as="a"
        href={href}
        onMouseEnter={onMouseEnter}
        suffixIcon={suffixIcon}
        prefixIcon={prefixIcon}
        fluid
      >
        {children}
      </TextButton>
    </Box>
  );
};
